import React, { useCallback, useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { numeric, RegexpTypes, required, dateFormat } from "@bappweb/utils"
import { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation } from "../../../api/services"
import { setQueryParams } from "src/projects/kobi-isbirlikleri/state/queryparams"
import { useAppDispatch } from "src/projects/kobi-isbirlikleri/config/hook"
import { getDayMonthYearFromStr, isNullOrEmpty } from "../../../../../utils/utils"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"

type PropsType = {
  cid: string
  ts: string
  formTitle: string
  onError?: (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => void
  onSubmit?: (event?: React.BaseSyntheticEvent, values?: Record<string, any>) => void
}

function MainForm({ onError, onSubmit, cid, ts, formTitle }: PropsType) {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const [identityNumber, setIdentityNumber] = useState('')
  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string>()
  const [isFetching, setIsFetching] = useState(false)
  const [radioType, setRadioType] = useState("VKN")
  const [applicationType, setApplicationType] = useState(1)
  const [vknNumber, setVknNumber] = useState("")


  const [getCaptcha] = useGetCaptchaMutation();

  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        tckn: identityNumber,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setError('')
            setCaptchaValues({
              ...captchaValues,
              showCaptcha: true,
              captchaData: payload.captchaData,
              captchaValidate: true
            })
          }
          else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => { setIsFetching(false) })
    }
  }, [captchaValues, getCaptcha, identityNumber])

  const handleRadioTypeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "TC") {
      setRadioType("TC")
      setApplicationType(2)
    } else {
      setRadioType("VKN")
      setApplicationType(1)

    }
  }, [])

  const [getTokenByTckn1] = useGetTokenByTckn1Mutation();

  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    switch (name) {
      case "identityNumber":
        setIdentityNumber(value)
        setCaptchaValues({
          ...captchaValues,
          tokenSessionId: "",
          showCaptcha: false,
          captchaData: ""
        })
        if (value.length === 11) {
          setIsFetching(true)
          getTokenByTckn1(value)
            .unwrap()
            .then((payload) => {
              if (!payload.IsError) {
                setError('')
                setCaptchaValues({
                  ...captchaValues,
                  tokenSessionId: payload.tokenSessionId,
                })
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            })
            .finally(() => { setIsFetching(false) })
        }
        break;
      case "captcha":
        setCaptchaValues({
          ...captchaValues,
          captcha: value,
          captchaValidate: true
        })
        break;
      default:
        break;
    }
  }, [getTokenByTckn1, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation();
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tckn: identityNumber,
      TokenSessionId: captchaValues.tokenSessionId,
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setError('')
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => { setIsFetching(false) })
  }, [refreshCaptcha, identityNumber, captchaValues])

  const [apply] = useApplyMutation()

  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && values?.birthdate && values.captcha) {
        dispatch(
          setQueryParams({
            cid: cid
          })
        )
        setIsFetching(true)
        const parsedBirthDate = getDayMonthYearFromStr(values.birthdate)
        apply({
          tckn: values.identityNumber,
          vkn: values.vknNumber,
          cepTel: "0090" + values.mobilePhone.replace(/\s/g, ''),
          dogumYil: parsedBirthDate.year,
          dogumAy: parsedBirthDate.month,
          dogumGun: parsedBirthDate.day,
          applicationType: applicationType,
          captcha: values.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          cid: cid,
          ts: ts,
          NextTransactionUrl: "Facebook/LeadKobi/Apply1",
          TokenSessionId: captchaValues.tokenSessionId,
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError('')
              history.push({
                pathname: "/details/smsotp",
                state: payload
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0,
              });
              refreshCaptcha({
                tckn: identityNumber,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  }
                  else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => { setIsFetching(false) })
            }
          })
          .finally(() => { setIsFetching(false) })
      }
      if (onSubmit) {
        onSubmit(e, values)
      }
    },
    [history, onSubmit, apply, captchaValues, identityNumber, vknNumber, refreshCaptcha]
  )

  const handleError = useCallback(
    (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => {
      //TODO:
      if (onError) {
        onError(event, errorField)
      }
    },
    [onError]
  )

  return (
    <Page>
      <Form onError={handleError} onSubmit={handleSubmit} onChange={handleChange} grid={false}>
        <Panel hasFooter connected={false}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description">
              {
                !ts
                  ? formTitle
                  : 'Kobi Dinamik Satış – Müşteri Edinimi'
              }
            </Element>
            <RadioGroup
              value={radioType}
              name="radioType"
              onChange={handleRadioTypeChange}
              block={false}>
              <Radio className="radioOne" label="Tüzel Firma Adına Başvuru (AŞ, Limited)" name="radioType" value="VKN" />
              <Radio label="Şahıs Şirketi Adına Başvuru" name="radioType" value="TC" />
            </RadioGroup>

            <TextField
              label='TC Kimlik No'
              type="text"
              name="identityNumber"
              maxLength={11}
              value={identityNumber}
              validator={RegexpTypes.Numeric}
              validations={[required("TC Kimlik Numarası alanı zorunludur."), numeric()]}
            />
            {radioType === "VKN" ? (<TextField
              type="text"
              name="vknNumber"
              label="Vergi Kimlik No"
              maxLength={10}
              value={vknNumber}
              validator={RegexpTypes.Numeric}
              validations={[required("Lütfen VKN Numaranızı giriniz")]}
            />) : null}

            <TextField
              label='Doğum Tarihi'
              type="text"
              placeholder="GG.AA.YYYY"
              mask="99.99.9999"
              name="birthdate"
              maxLength={10}
              validations={[
                required("Doğum Tarihi alanı zorunludur."),
                dateFormat("Lütfen Geçerli Bir Tarih Giriniz")
              ]}
            />
            <TextField
              label='Cep Telefon No'
              type="text"
              placeholder="5__ ___ __ __"
              mask="999 999 99 99"
              name="mobilePhone"
              maxLength={13}
              validations={[required("Cep Telefonu alanı zorunludur.")]}
            />
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                captchaValidate={captchaValues.captchaValidate}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
              />
            )}
            <Checkbox
              name="checkboxKvkk"
              validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
              className="cb-position-fix"
              block
            >
              <Link
                href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                text={"Kişisel Verilerin Korunması Kanunu"}
                inline
                target="_blank"
              />
              {" hakkında bilgilendirme'yi okudum."}
            </Checkbox>
          </Panel.Body>
          <Panel.Footer>
            <Panel.RightFooter>
              <Button text="DEVAM" type="submit" fetching={isFetching} disabled={isFetching}
                onClick={() =>
                  setCaptchaValues({
                    ...captchaValues,
                    captchaValidate: true
                  })
                } />
            </Panel.RightFooter>
          </Panel.Footer>
        </Panel>
      </Form>
      <Element type="p" className="form-information-text">{"**Gerekli durumlarda işleminizin tamamlanabilmesi için Müşteri İletişim Merkezimiz sizinle iletişime geçecektir."}</Element>
    </Page>
  )
}

export default MainForm
